import { render } from "./AddonViewIndex.vue?vue&type=template&id=750d7b0d&scoped=true&ts=true"
import script from "./AddonViewIndex.vue?vue&type=script&lang=ts"
export * from "./AddonViewIndex.vue?vue&type=script&lang=ts"

import "./AddonViewIndex.vue?vue&type=style&index=0&id=750d7b0d&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-750d7b0d"]])

export default __exports__